import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { generatePath } from "react-router-dom";
import useAuth from "hooks/useAuth";

export default function useRemoveAcquistion() {
  const queryClient = useQueryClient();
  const { me } = useAuth();

  const removeAcquistion = (id: string) => {
    const request: Request = {
      url: generatePath(ENDPOINTS.acquisitions.remove, { id }),
      config: {
        method: "patch",
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<Response<null>, Error, string>(
    removeAcquistion,
    {
      onSettled: (data, error, id) => {
        queryClient.invalidateQueries([ENDPOINTS.acquisitions.one, id]);
        queryClient.invalidateQueries([ENDPOINTS.acquisitions.all]);
        me();
      },
    }
  );

  return { data, mutate, ...rest };
}
